import StorageDataModelPlayback from "./playback/storage-data-model-playback"
import StorageDataModelSource from "./source/storage-data-model-source"
import StorageDataModelTheme from "./theme/storage-data-model-theme"
import StorageDataModelWrapper from "./wrapper/storage-data-model-wrapper"

/**
 * The storage data model for the `NPO player`.
 * 
 * @author Stan Hurks
 */
export default class StorageDataModel {

    /**
     * Data related to the wrapper application.
     */
    public wrapper: StorageDataModelWrapper = new StorageDataModelWrapper()

    /**
     * Data related to the theme.
     */
    public theme: StorageDataModelTheme = new StorageDataModelTheme()

    /**
     * Data related to the playback
     */
    public playback: StorageDataModelPlayback = new StorageDataModelPlayback()

    /**
     * Data related to the video source.
     */
    public source: StorageDataModelSource = new StorageDataModelSource()
}